export default {
    carregando: false,
    items: [],
    tipoAgings: [],
    selecionado: {}
}